export async function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export async function retry(fn, delay = 100, limit = 10, round = 0) {
  try {
    const results = await fn()
    return results
  } catch (error) {
    if (round !== limit) {
      await sleep(delay)
      return retry(fn, delay, limit, round + 1)
    }
    throw error
  }
}

export default { retry, sleep }


// WEBPACK FOOTER //
// ./src/utils/general.js